import {axios} from "@/utils"

const endpoints = {
    get_all_medias: 'v3/checkins/{checkin_id}/all-medias/', // Feat see all medias
    get_medias: '/v3/medias/',
    get_galleries: '/v3/checkins/{checkin_id}/galleries/',
    get_gallery_medias: '/v3/checkins/{checkin_id}/galleries/{gallery_id}/medias/',
    add_favorite: '/v3/medias/{media_id}/add-favorite/',
    remove_favorite: '/v3/medias/{media_id}/remove-favorite/'
}

export default {
    async getAllMedias(checkin_id, params) {
        const response = await axios.get(endpoints.get_all_medias.replace('{checkin_id}', checkin_id), {params})
        return response.data
    },
    async getMedias(params) {
        const response = await axios.get(endpoints.get_medias, {params})
        return response.data
    },
    async getGalleries(checkin_id) {
        const response = await axios.get(endpoints.get_galleries.replace('{checkin_id}', checkin_id))
        return response.data
    },
    async getMediasByGallery(checkin_id, gallery_id, params) {
        const response = await axios.get(endpoints.get_gallery_medias.replace('{checkin_id}', checkin_id).replace('{gallery_id}', gallery_id), {params})
        return response.data
    },
    async addFavorite(media_id) {
        const response = await axios.post(endpoints.add_favorite.replace('{media_id}', media_id))
        return response.data
    },
    async removeFavorite(media_id) {
        const response = await axios.post(endpoints.remove_favorite.replace('{media_id}', media_id))
        return response.data
    }

}